import React, { useState } from 'react';
import { Briefcase, Lock, Mail, User } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const API = '/api';

const EmployeeSetup = () => {
  const [email, setEmail] = useState('');
  const [engineerId, setEngineerId] = useState('1');
  const [adminPassword, setAdminPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const engineers = [
    { id: 1, name: 'Trap Spade' },
    { id: 2, name: 'Papi Yungstar' },
    { id: 3, name: 'Savant' },
    { id: 4, name: 'Young Chop' }
  ];

  const handleSetupEmployee = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/employees/setup`, {
        email: email,
        engineer_id: parseInt(engineerId),
        admin_password: adminPassword
      });
      
      toast.success(response.data.message);
      toast.info('Please logout and login again to access employee dashboard');
      
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Employee setup error:', error);
      toast.error(error.response?.data?.detail || 'Failed to setup employee');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-gray-900 to-black border border-purple-500/30 rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-600/20 rounded-full mb-4">
            <Briefcase className="text-purple-400" size={32} />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Employee Setup</h1>
          <p className="text-gray-400">Setup employee/engineer access</p>
        </div>

        <form onSubmit={handleSetupEmployee} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Employee Email Address
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="engineer@studio.com"
                className="w-full pl-10 pr-4 py-3 bg-black/40 border border-purple-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              The email of the account to setup as employee
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Select Engineer
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <select
                value={engineerId}
                onChange={(e) => setEngineerId(e.target.value)}
                className="w-full pl-10 pr-4 py-3 bg-black/40 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:border-purple-500 appearance-none"
              >
                {engineers.map((eng) => (
                  <option key={eng.id} value={eng.id} className="bg-gray-900">
                    {eng.name}
                  </option>
                ))}
              </select>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Which engineer is this employee?
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Admin Secret Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="password"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="w-full pl-10 pr-4 py-3 bg-black/40 border border-purple-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              The same password used for /admin panel access
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Setting up...' : 'Setup Employee Access'}
          </button>
        </form>

        <div className="mt-6 p-4 bg-blue-900/20 border border-blue-500/30 rounded-lg">
          <p className="text-sm text-blue-200">
            <strong>Note:</strong> The user must first create a regular account, then use this page to upgrade to employee.
          </p>
        </div>

        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-purple-400 hover:text-purple-300 text-sm"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSetup;
